/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import CardBase from 'DesignSystem/CardBase/index'
import LineChart from 'DesignSystem/LineChart/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/LineChart/Content"
  
}) {
let leadsHistoryValueData = fromData.useDataFormat({ viewPath,
context: 'leads_history',
format: fromHelpers.lineChart,
})
let leadsHistoryValueData1 = fromData.useDataValue({ viewPath,
context: 'leads_history',
})
let aggregateData = fromHelpers.legend(leadsHistoryValueData1)
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<CardBase
  viewPath={`${viewPath}/CardBase`}
 fleDirection="row"
 alignSelf="stretch"
 backgroundColor="#fff"
 shadowColor="rgba(0, 0, 0, 0)"
>
{childProps => (
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<LineChart
  viewPath={`${viewPath}/LineChart`}
 data="leads_history"
 format="./helpers.js lineChart"
 value={leadsHistoryValueData}
 multiline={true}
 offsetY={4}
 height={60}
 width={600}
 data="leads_history"
 aggregate="./helpers.js legend"
 legend={aggregateData}
/>
</div>
)}
</CardBase>
</div>
{children}
</React.Fragment>)
}